import { FrequencyCappingSection as SharedFrequencyCappingSection } from '@openx/components-form/FrequencyCapping/FrequencyCappingSection';
import { type DealFormData, dealFormField } from '@openx/types/deal';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const buildDealDeleteButtonTestId = (index: number) => `delete-icon-${index}`;

type FrequencyCappingSectionProps = {
  isDisabled?: boolean;
  disabledInfo?: ReactNode;
};

export const FrequencyCappingSection = ({ isDisabled, disabledInfo }: FrequencyCappingSectionProps) => {
  const { t } = useTranslation();

  const infoAlertItems = [
    <span key="utc">
      {t('The Frequency Cap operates according to the')} <strong>{t('UTC')}</strong> {t('time zone.')}
    </span>,
    <span key="apply-delay">
      {t('Any changes in Frequency Capping will be applied in')} <strong>{t('15 minutes')}</strong>{' '}
      {t('after saving the form.')}
    </span>,
  ];

  return (
    <SharedFrequencyCappingSection<DealFormData>
      name={dealFormField.FREQUENCY_CAPPING}
      infoAlertItems={infoAlertItems}
      getDeleteButtonTestId={buildDealDeleteButtonTestId}
      isDisabled={isDisabled}
      disabledInfo={disabledInfo}
    />
  );
};
